<div [ngClass]="showAsButtonLink ? 'btn-link-group-toggle' : 'btn-group-toggle'">
    <ng-content></ng-content>
</div>
